<template>
  <div class="flex flex-col gap-y-3">
    <template v-if="!isLoading">
      <UserProfileSponsorSection
        panelTitle="validationGatewayDetails"
        :show-flags="{
          showEnglishName: true,
          showArabicName: true,
          showDepartment: false,
          showSponsorType: false,
          showLicenseIssueDate: false,
          showNumber: false
        }"
        :labels="{
          englishName: 'EstabEnName',
          arabicName: 'EstabArName'
        }"
        title="subscriptionDetails"
      >
        <template #moreRows>
          <div class="w-full md:w-1/2 flex flex-col md:flex-row items-start gap-x-1 p-0.5">
            <span class="md:w-1/3 pt-0.5 ltr:font-sans font-bold text-brand-black-body text-xs">
              {{ $t('SubscriptionStauts') }}:
            </span>
            <span
              :class="{
                'text-brand-red': ['subscriptionNotFound', 'subscriptionInactive'].includes(
                  subscriptionStatus
                ),
                'text-brand-green': subscriptionStatus == 'subscriptionActive'
              }"
              class="md:w-2/3"
            >
              {{ $t(subscriptionStatus) }}
            </span>
          </div>
        </template>
      </UserProfileSponsorSection>

      <CollapsibleSection
        v-if="subscriptionStatus == 'subscriptionActive'"
        :header-label="$t('TheCurrentServices')"
        body-class="flex flex-wrap"
      >
        <DataTable :default-headers="['ServicesName', 'SubscriptionDatePretty']" :rows="dataSet">
        </DataTable>
      </CollapsibleSection>
    </template>
  </div>
</template>

<script setup>
import CollapsibleSection from '@/components/Ui/CollapsibleSection.vue'
import axiosInstance from '@/services'
import { useAuthStore } from '@/stores/auth'
import UserProfileSponsorSection from '@/views/auth-user/user-profile/UserProfileSponsorSection.vue'
import { DateTime } from 'luxon'
import { computed, onMounted, ref } from 'vue'
import DataTable from '@/components/DataTable/index.vue'

const authStore = useAuthStore()

const isLoading = ref(true)
const currentServices = ref()

const formatDate = (date) => DateTime.fromISO(date).toFormat('dd/MM/yyyy')

const subscriptionStatus = computed(() => {
  if (!currentServices.value || currentServices.value?.numberOfRecords === 0) {
    return 'subscriptionNotFound'
  }

  return currentServices.value.collection[0].holdDate
    ? 'subscriptionActive'
    : 'subscriptionInactive'
})

const dataSet = computed(() => {
  if (!currentServices.value || (!currentServices.value?.collection || []).length === 0) return null

  return currentServices.value.collection.map((c) => {
    return {
      ServicesName: c.lookupValidGetwayService.label,
      SubscriptionDatePretty: formatDate(c.creationDate)
    }
  })
})

onMounted(async () => {
  const params = {
    estabId: authStore.establishmentInfo.id
  }

  currentServices.value = await axiosInstance.get('/api/establishment/getCurrentServices', {
    params
  })

  isLoading.value = false
})
</script>

<style lang="scss" scoped></style>
